import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.Save.IRequest;
type Response = Api.Core.ProductPricingPlan.Save.IResponse;
type Headers = Api.Core.ProductPricingPlan.Save.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlan';
export default async function productPricingPlanSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
